<i18n locale="en">
{
  "label": "Corners",
  "options": {
    "rounded": "Rounded",
    "square": "Square"
  }
}
</i18n>

<template>
  <OwnInputContainer :label="t('label')">
    <OwnSegmentedControl
      :model-value="themeCorners"
      :options="options"
      @update:model-value="onCornerUpdate"
    />
  </OwnInputContainer>
</template>

<script>
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions } from 'vuex'

import { useMergedTheme } from '@/lib/builder/public/preview/mixins/useMergedTheme'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSegmentedControl } from '@/ui/OwnSegmentedControl'

const options = [
  {
    value: 'rounded',
  },
  {
    value: 'square',
  },
]

export default {
  name: 'BorderStyleEditor',
  components: {
    OwnInputContainer,
    OwnSegmentedControl,
  },
  inject: ['storeModule'],
  mixins: [useMergedTheme],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  data() {
    return {
      options: options.map((option) => ({
        ...option,
        label: this.t(`options.${option.value}`),
      })),
    }
  },
  computed: {
    themeCorners() {
      const { mergedTheme } = this

      const controlRadius = mergedTheme?.borderRadius.control

      if (controlRadius > 0) {
        return 'rounded'
      } else {
        return 'square'
      }
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    async onCornerUpdate(newValue) {
      let update

      if (newValue === 'rounded') {
        update = set({}, 'theme.overrides.borderRadius.primary', 0.5)
      } else {
        update = set({}, 'theme.overrides.borderRadius.primary', 0)
      }

      await this.updateResource(update)
    },
  },
}
</script>
